'use client';

import { SvgShoppingBasketFill } from '@common/icon';

import { CustomLink } from '@/app/_components/CustomLink';
import { useMarketCart } from '@/app/welmarket/cart/_hooks/useMarketCart';
import { WEL_MARKET_ROUTES } from '@/constants';

export const CartButton = () => {
  const { totalCount } = useMarketCart();

  return (
    <CustomLink
      href={WEL_MARKET_ROUTES.CART.pathname}
      aria-label="장바구니"
      className="relative size-26"
    >
      <SvgShoppingBasketFill className="size-24 text-Gray-900" />
      {totalCount > 0 ? (
        <span className="absolute -right-6 -top-4 flex size-16 items-center justify-center rounded-pill bg-R-500 font-600 text-Gray-white typo-caption2">
          {totalCount > 99 ? '99+' : totalCount}
        </span>
      ) : null}
    </CustomLink>
  );
};
